/* @flow */
import SchoolViewChartFigure from './SchoolViewChartFigure';

export default SchoolViewChartFigure;
